"use client"

import { ThemeToggle } from "@/components/auth/theme-toggle"
import {DollarSignIcon} from "lucide-react"
import { LocaleToggle } from "@/components/auth/locale-toggle"
import { ReactNode } from "react"
import { useTranslation } from "@/components/app/i18n-provider"

export default function AuthLayout({ children }: { children: ReactNode }) {
    const { t } = useTranslation()

    return (
        <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
            <div className="absolute right-4 top-4 md:right-8 md:top-8">
                <span className="mr-1 ml-1">
                    <ThemeToggle />
                </span>
                <span className="mr-1 ml-1">
                    <LocaleToggle />
                </span>
            </div>
            <div className="flex w-full max-w-sm flex-col gap-6">
                <a href="#" className="flex items-center gap-2 self-center font-medium">
                    <div className="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
                        <DollarSignIcon className="size-4" />
                    </div>
                    <span className="font-bold">
                        {t("auth.brand")}
                    </span>
                </a>
                {children}
            </div>
        </div>
    )
}
